/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      function filterResources( category, topic, contentType, searchTerm, order, paged = 1 ) {
        const data = {
          category: category,
          topic: topic,
          contentType: contentType,
          searchTerm: searchTerm,
          order: order,
          paged: paged,
        };
        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'cpt/filter',
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            console.log( data );
            $( '.resources-archive .ajax-area' ).html( data.new_resources );
            $( '.resources-archive .showing' ).text( $( '.resources-archive .resources-grid' ).attr( 'data-showing' ) );
            $( '.resources-archive .total' ).text( $( '.resources-archive .resources-grid' ).attr( 'data-total' ) );

            if ( $( '.resources-archive .resources-grid' ).attr( 'data-all-loaded' ) == '1' ) {
              $( '.load-more-posts' ).hide();
            } else {
              $( '.load-more-posts' ).show();
            }
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
          error: function( xhr, exception ) {
            let msg = '';
            if ( xhr.status === 0 ) {
              msg = 'Not connect.\n Verify Network.' + xhr.responseText;
            } else if ( xhr.status == 404 ) {
              msg = 'Requested page not found. [404]' + xhr.responseText;
            } else if ( xhr.status == 500 ) {
              msg = 'Internal Server Error [500].' + xhr.responseText;
            } else if ( exception === 'parsererror' ) {
              msg = 'Requested JSON parse failed.';
            } else if ( exception === 'timeout' ) {
              msg = 'Time out error.' + xhr.responseText;
            } else if ( exception === 'abort' ) {
              msg = 'Ajax request aborted.';
            } else {
              msg = 'Error:' + xhr.status + ' ' + xhr.responseText;
            }
            console.log( msg );
          },
        } );
      }

      const category = $( '.resources-archive' ).attr( 'data-category' );
      const topic = [];
      $( '.resources-archive .resource-filters input[name=\'topic[]\']:checked' ).each( function() {
        topic[topic.length] = ( this.checked ? $( this ).val() : '' );
      } );

      const contentType = [];
      $( '.resources-archive .resource-filters input[name=\'content-type[]\']:checked' ).each( function() {
        contentType[contentType.length] = ( this.checked ? $( this ).val() : '' );
      } );

      const searchTerm = $( '.resources-archive .resource-filters input[name="search"]' ).val();
      const order = $( '.resources-archive select[name="order"]:selected' ).val();

      filterResources( category, topic, contentType, searchTerm, order );

      $( '.resources-archive .resource-filters input, .resources-archive select' ).on( 'change', function() {
        const category = $( '.resources-archive' ).attr( 'data-category' );
        const topic = [];
        $( '.resources-archive .resource-filters input[name=\'topic[]\']:checked' ).each( function() {
          topic[topic.length] = ( this.checked ? $( this ).val() : '' );
        } );

        const contentType = [];
        $( '.resources-archive .resource-filters input[name=\'content-type[]\']:checked' ).each( function() {
          contentType[contentType.length] = ( this.checked ? $( this ).val() : '' );
        } );
        const searchTerm = $( '.resources-archive .resource-filters input[name="search"]' ).val();
        const order = $( '.resources-archive select[name="order"] :selected' ).val();
        $( '.resources-archive .load-more-posts' ).attr( 'data-page', '1' );

        filterResources( category, topic, contentType, searchTerm, order );
      } );

      $( document ).on( 'click', '.load-more-posts', function() {
        const category = $( '.resources-archive' ).attr( 'data-category' );
        const topic = [];
        $( '.resources-archive .resource-filters input[name=\'topic[]\']:checked' ).each( function() {
          topic[topic.length] = ( this.checked ? $( this ).val() : '' );
        } );

        const contentType = [];
        $( '.resources-archive .resource-filters input[name=\'content-type[]\']:checked' ).each( function() {
          contentType[contentType.length] = ( this.checked ? $( this ).val() : '' );
        } );
        const searchTerm = $( '.resources-archive .resource-filters input[name="search"]' ).val();
        const order = $( '.resources-archive select[name="order"] :selected' ).val();
        const paged = parseInt( $( '.resources-archive .load-more-posts' ).attr( 'data-page' ) ) + 1;
        $( '.resources-archive .load-more-posts' ).attr( 'data-page', paged );

        filterResources( category, topic, contentType, searchTerm, order, paged );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'resources', COMPONENT );
} )( app );
